module.exports = __webpack_public_path__ + "img/if_2.dbc38a70.png";